const directive = (el) => {
  el.addEventListener('keypress', (event) => {
		const charCode = event.charCode;
		if (charCode < 48 || charCode > 57) {
				event.preventDefault();
		}
	});

  el.addEventListener('paste', (event) => {
    const paste = (event.clipboardData || window.clipboardData).getData('text');
    if (!/^[0-9]*$/.test(paste)) {
      event.preventDefault();
    }
  });
}
  
export default directive;
  